import { onContentReady } from "@story/story_assets/utils";

//
// Loaded images
//
onContentReady(function(parent) {
	for (let element of parent.querySelectorAll("img.img-jpg, img.img-png")) {
		function loaded() {
			element.classList.remove("img-jpg", "img-png");
		}

		if (element.complete) {
			loaded();
		}
		else {
			element.addEventListener("load", loaded, { once: true });
		}
	}
});